import React from 'react';
import { useRefCallback } from 'src/utils/react/ref-callback.hook';

type KeyMatchCondition = {
  key: string;
  cmd?: boolean;
  shift?: boolean;
};

export function useGlobalHotkeyDialogTrigger(condition: KeyMatchCondition): {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
} {
  const [open, setOpen] = React.useState(false);

  const keydownMatcher = useRefCallback(
    (e: KeyboardEvent) => {
      const { key, cmd, shift } = condition;
      return (
        e.key === key &&
        (cmd === undefined || (navigator?.platform?.toLowerCase().includes('mac') ? e.metaKey : e.ctrlKey) === cmd) &&
        (shift === undefined || e.shiftKey === shift)
      );
    },
    [condition]
  );

  React.useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (keydownMatcher(e)) {
        e.preventDefault();
        e.stopPropagation();

        setOpen((open) => !open);
      }

      // if the user pressed escape, close the command palette
      if (e.key === 'Escape') {
        setOpen(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [keydownMatcher]);

  return { open, setOpen };
}
